// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"9188b0f8","769":"4da44096"}[chunkId] + ".chunk.js";
};